<template>
  <div class="m-edition-section-content-footer">
    <span>Vidroop.com © {{ $moment().year() }}</span>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionSectionContentFooter'
}
</script>
